var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarStarsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14.6667,
    height: 14.6667,
    viewBox: "0 0 14.6667 14.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33333L12.8333 3.5L14.6667 2.66667L12.8333 1.83333L12 0L11.1667 1.83333L9.33333 2.66667L11.1667 3.5L12 5.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33333L11.1667 11.1667L9.33333 12L11.1667 12.8333L12 14.6667L12.8333 12.8333L14.6667 12L12.8333 11.1667L12 9.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.66667L5.33333 2L3.66667 5.66667L0 7.33333L3.66667 9L5.33333 12.6667L7 9L10.6667 7.33333L7 5.66667ZM5.99333 7.99333L5.33333 9.44667L4.67333 7.99333L3.22 7.33333L4.67333 6.67333L5.33333 5.22L5.99333 6.67333L7.44667 7.33333L5.99333 7.99333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarStarsWhite);
export default __webpack_public_path__ + "static/media/avatar-stars-white.daaa21cfcce35c52360840ccb14b39ad.svg";
export { ForwardRef as ReactComponent };